export const WiggotNewsVideo = () => (
  <div
    className="w-full h-[300px]"
    dangerouslySetInnerHTML={{
      __html: `<iframe style="border:none" src=https://www.youtube.com/embed/d_xFeq8Us4s?rel=0&modestbranding=1&iv_load_policy=3 title=video width="100%" height="100%" allowfullscreen></iframe>`
    }}
  />
)
